// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor-node_modules_block_request_lib_index_js-node_modules_block_utils_lib_index_js-node_mod-257c4a"], function() { return __webpack_require__("./app/src/index.tsx"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
